import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { EnvContextProvider, fn } from 'next-common-lib';
import store from 'redux/store/configureStore';
import App from 'App';
import 'i18n';
import 'assets/style/common.scss';
import 'next-common-lib/dist/esm/common_lib_styles.css';

fn.setDomainHost();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <EnvContextProvider>
      <App />
    </EnvContextProvider>
  </Provider>,
);
